import { memo, useState } from 'react'
import AddProductModal from '../modal/AddProductModal'

function AddProductsButton({ category, products, setProducts, products_types }) {
  const [newProduct, setShowModal] = useState(false)

  const addNewProduct = () => {
    setShowModal(true)
  }

  return (
    <>
      <button
        type={'button'}
        onClick={addNewProduct}
        className="w-full md:w-fit shadow-add-more h-11 mx-auto px-5 py-2.5 text-md font-medium text-white
                flex items-center justify-center bg-blue rounded-md hover:bg-link
                transition-all duration-300 ease-linear whitespace-nowrap"
      >
        <span className={'text-white pl-2'}>افزودن محصول</span>
        <i className={'icon-add text-white'} />
      </button>
      {newProduct && (
        <AddProductModal
          category={category}
          newProduct={newProduct}
          products={products}
          setProducts={setProducts}
          products_types={products_types}
          setShowModal={setShowModal}
        />
      )}
    </>
  )
}

export default memo(AddProductsButton)
